export const FETCH_WARRANTY_TABLE_START = "FETCH_WARRANTY_TABLE_START";
export const FETCH_WARRANTY_TABLE_SUCCESS = "FETCH_WARRANTY_TABLE_SUCCESS";
export const FETCH_WARRANTY_TABLE_FAIL = "FETCH_WARRANTY_TABLE_FAIL";
